import { z } from "zod";

const recipientEmail = z
  .string()
  .email()
  .max(255, "Email must be 255 characters or fewer");

export const responsibilityMapSchema = z.object({
  responsibility: z.string().min(1, "Responsibility is required"),
  region: z.string().min(1, "Region is required"),
  salesEmails: z
    .array(recipientEmail)
    .min(1, "At least one sales email is required"),
  engineeringEmails: z
    .array(recipientEmail)
    .min(1, "At least one engineering email is required"),
});

export type ResponsibilityMapFormData = z.infer<typeof responsibilityMapSchema>;
